import { IsBoolean, IsEmail, IsOptional, IsString } from 'class-validator';

export class UpsertEmpresaCorreoDto {
  @IsBoolean()
  usar_correo_propio: boolean;

  @IsString()
  @IsOptional()
  host?: string;

  @IsString()
  @IsOptional()
  puerto?: string;

  @IsString()
  @IsOptional()
  username?: string;

  @IsString()
  @IsOptional()
  password?: string;

  @IsEmail()
  @IsOptional()
  email?: string;

  @IsBoolean()
  @IsOptional()
  envio_ssl?: boolean;

  @IsBoolean()
  @IsOptional()
  template_personalizado?: boolean;

  @IsBoolean()
  @IsOptional()
  adjunto?: boolean;
}

export class TestEmailDto {
  @IsEmail()
  destinatario: string;
}
